import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import axios from 'axios';
import { getHost } from './config';
import { getTransFunc } from '../../Basic/SFxLocalization';
import { notifyErrorToast } from '../utils/errorToast';
var errorMsg = {
  '401': 'SFx401Error',
  '403': 'SFx403Error',
  '500': 'SFx500Error'
}; // eslint-disable-next-line

var handleError = function handleError(error, settings) {
  var _error$response;

  var status = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
  var catchError = settings.catchError;
  var trans = getTransFunc();

  if (!catchError && Number(status) !== 404) {
    var errorKey = errorMsg[status] || 'SFxUnknownError';
    var description = trans(errorKey);
    /**
     * 1. Print error log
     * 2. Show error toast
     */

    notifyErrorToast(description, error);
  }
}; //global setting


axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
var api = axios.create();

var _ref = getHost ? getHost() : {},
    _ref$apiServiceSettin = _ref.apiServiceSetting,
    apiServiceSetting = _ref$apiServiceSettin === void 0 ? {} : _ref$apiServiceSettin;

api.interceptors.request.use(function (config) {
  return _objectSpread(_objectSpread({}, config), apiServiceSetting);
});

var request = function request(url, method, params, settings) {
  var _getHost = getHost(),
      apiHost = _getHost.apiHost,
      getToken = _getHost.getToken;

  var token = getToken();

  if (token) {
    api.defaults.headers.Authorization = "Bearer ".concat(token);
  }

  api.defaults.baseURL = settings.overrideBaseURL ? settings.overrideBaseURL : apiHost;
  return api[method](url, params).catch(function (error) {
    // if you need to catch error, set settings value with '{catchError:true}'
    handleError(error, settings);
    return Promise.reject(error);
  });
};

var apiService = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  post: function post(url, params) {
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return request(url, 'post', params, settings);
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  get: function get(url, params) {
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return request(url, 'get', params, settings);
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  delete: function _delete(url, params) {
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return request(url, 'delete', params, settings);
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  put: function put(url, params) {
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return request(url, 'put', params, settings);
  }
};
export default apiService;